module.exports = __webpack_public_path__ + "static/media/Tighnari.a15445b2.png";